import * as yup from "yup";
import { useState, useEffect } from "react";
import { useQuery } from "@apollo/client";
import { GET_PARTNERS } from "GraphQl/Queries/Partner";
import { GET_INSTRUCTOR_ID_NAME } from "GraphQl/Queries/Courses";
import { COURSES_QUERY } from "GraphQl/Queries/Courses";
import { GET_ALL_LANGUAGES } from "GraphQl/Queries/Languages";

function BatchFormBuilder(values) {
  const [schema, setSchema] = useState({});
  const [instructors, setInstructors] = useState([{}]);
  const [courseOptions, setCourses] = useState([{}]);
  const [languageOptions, setLanguages] = useState([{}]);
  const [partnerOptions, setPartnerOptions] = useState([]);
  const [allPartners, setAllPartners] = useState([]); // full data with nested projects
  const [projectOptions, setProjectOptions] = useState([]);
  const instructorIdName = useQuery(GET_INSTRUCTOR_ID_NAME, {
    onCompleted: (data) => {
      const instructorOptions = data.courses_instructor.map((inst, i) => {
        return {
          value: inst.id,
          label: inst.name + " - " + inst.email,
        };
      });
      setInstructors(instructorOptions);
    },
  });

  const coursesName = useQuery(COURSES_QUERY, {
    onCompleted: (data) => {
      const options = data.courses_course.map((course, i) => {
        return {
          value: course.id,
          label: course.full_name,
        };
      });
      setCourses(options);
    },
  });

  const allLanguage = useQuery(GET_ALL_LANGUAGES, {
    onCompleted: (data) => {
      const options = data.courses_languages.map((lang, i) => {
        return {
          value: lang.id,
          label: lang.display_name,
        };
      });
      setLanguages(options);
    },
  });

  useQuery(GET_PARTNERS, {
    onCompleted: (data) => {
      setAllPartners(data.courses_partner);
      setPartnerOptions(
        data.courses_partner.map((p) => ({ value: p.id, label: p.name })),
      );
    },
  });
  useEffect(() => {
    const selectedPartnerId = parseInt(values?.partner_id);
    if (selectedPartnerId) {
      const partner = allPartners.find((p) => p.id === selectedPartnerId);
      setProjectOptions(
        partner?.projects?.map((p) => ({ value: p.id, label: p.name })) || [],
      );
    } else {
      setProjectOptions([]);
    }
  }, [values?.partner_id, allPartners]);
  useEffect(() => {
    const schema = {
      batch_name: {
        label: "Batch Name",
        required: false,
        type: "text",
      },
      course_id: {
        type: "select",
        label: "Course",
        required: false,
        options: courseOptions,
      },
      language_id: {
        type: "select",
        label: "Batch Language",
        required: false,
        options: languageOptions,
      },
      from_date: {
        label: "Start Date",
        required: false,
        type: "date",
      },
      to_date: {
        label: "End Date",
        type: "date",
        required: false,
      },
      slot_start_time: {
        type: "time",
        label: "Slot Start Time",
        required: false,
      },

      slot_end_time: {
        type: "time",
        label: "Slot End Time",
        required: false,
      },
      instructor_id: {
        type: "select",
        label: "Update Trainer",
        required: false,
        options: instructors.map((instructor) => ({
          value: instructor.value,
          label: instructor.label,
        })),
      },
      registration_end_date: {
        label: "Registration End Date",
        type: "date",
        required: false,
      },
      max_learners: {
        label: "Max Learners",
        type: "number",
        required: false,
      },
      partner_id: {
        type: "select",
        label: "Partner",
        required: false,
        options: partnerOptions,
      },
      project_id: {
        type: "select",
        label: "Project",
        required: false,
        options: projectOptions,
      },
    };
    setSchema(schema);
  }, [
    values,
    instructors,
    languageOptions,
    courseOptions,
    partnerOptions,
    projectOptions,
  ]);

  return schema;
}

export default BatchFormBuilder;
